import { render, staticRenderFns } from "./KETPsaDetails.vue?vue&type=template&id=589f0a43&"
import script from "./KETPsaDetails.vue?vue&type=script&lang=js&"
export * from "./KETPsaDetails.vue?vue&type=script&lang=js&"
import style0 from "./KETPsaDetails.vue?vue&type=style&index=0&id=589f0a43&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports